export default __webpack_public_path__ + "static/assets/6e92be1187ef5e0f11677171fb5fa991.svg";